module.exports = __webpack_public_path__ + "img/logo-dark.b3a6e93d.svg";